import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
  TextField,
  MenuItem,
  Button,
  Card,
  CardContent,
  Typography,
  IconButton,
  Box,
  Grid,
  Autocomplete,
} from "@mui/material";
import {
  createCantine,
  fetchCantines,
  fetchCantinesById,
  fetchProductionTypes,
  updateCantineAsync,
  // certifyCantina,
} from "../../../features/cantine/cantineThunk";
import { certificationProcess } from "../../../services/apiForCertifications";
import { useDispatch, useSelector } from "react-redux";
import { selectProductionTypes } from "../../../features/cantine/cantineSlice";
import {
  selectCities,
  selectProvincies,
  selectRegions,
} from "../../../features/region/regionSlice";
import { fetchRegions, fetchCities, fetchProvincies } from "../../../features/region/regionThunk";


const schema = yup.object().shape({
  name: yup.string().required("Nome stabilimento è obbligatorio"),
  tipo_di_produzione: yup.mixed().required("Tipo di produzioneè obbligatoria"),
  // tipoAzienda: yup.string().required("Tipo di azienda è obbligatoria"),
  // codRegistro: yup.string().required("Cod. Registro imprese è obbligatoria"),
  // codAteco: yup.string().required("Cod. ATECO è obbligatoria"),
  // dataCostituzione: yup.string().required("Data costituzione è obbligatoria"),
  address: yup.string().required("Indirizzo è obbligatoria"),
  city: yup.string().required("Città è obbligatoria"),
  zip_code: yup.string().required("CAP è obbligatoria").matches(/^\d{5}$/, "Il CAP deve essere composto esattamente da 5 cifre"),
  region: yup.string().required("FR è obbligatoria"),
  state: yup.string().required("Regione è obbligatoria"),
  nazione: yup.string().required("Nazione è obbligatoria"),
  phone: yup.string().matches(/^\d+$/, "Il Telefono deve essere un numero valido").required("Telefono è obbligatoria"),
  email: yup.string().email("Invalid email").required("Email è obbligatoria"),
  pec: yup.string().required("PEC è obbligatoria"),
  website: yup.string().required("Sito web è obbligatoria"),
  manager_name: yup.string().required("Nome è obbligatoria"),
  manager_phone: yup.string().matches(/^\d+$/, "Il Numero deve essere un numero valido").required("Numero è obbligatoria"),
  manager_email: yup
    .string()
    .email("Il Numero deve essere un numero valido")
    .required("Mail è obbligatoria"),
});

const CantineForm = ({ cantine, singleData, setCantine }) => {  // cantine --> undefined (--> if there is cantine(!)) or true (--> if there isn't (!))

  // console.log('cantine: ', cantine)

  const dispatch = useDispatch();
  const [certificationResponse, setCertificationResponse] = useState(null);
  const [certificationLoading, setCertificationLoading] = useState(false);
  const productionTypes = useSelector(selectProductionTypes);
  const regions = useSelector(selectRegions);
  const cities = useSelector(selectCities);
  const provincies = useSelector(selectProvincies);
  const cantinaId = singleData?.id;


  const { control, handleSubmit, reset, formState: { errors } } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      name: singleData?.name || "",
      tipo_di_produzione: singleData?.tipo_di_produzione ? singleData.tipo_di_produzione : [],      
      address: singleData?.address || "",
      city: singleData?.city || "",
      zip_code: singleData?.zip_code || "",
      region: singleData?.region || "",
      state: singleData?.state || "",
      nazione: singleData?.nazione || "",
      phone: singleData?.phone || "",
      email: singleData?.email || "",
      pec: singleData?.pec || "",
      website: singleData?.website || "",
      manager_name: singleData?.manager_name || "",
      manager_phone: singleData?.manager_phone || "",
      manager_email: singleData?.manager_email || "",
      provincies:singleData?.provincies
    },
  });

  useEffect(() => {
    dispatch(fetchProductionTypes());
    dispatch(fetchRegions())
    dispatch(fetchProvincies())
    dispatch(fetchCities())
    reset({
      ...singleData,
      tipo_di_produzione: singleData?.tipo_di_produzione
    });  
  }, [dispatch, reset, singleData]);


  const onSubmit = async (data) => {
    try {
      const cantineData = {
        name: data.name,
        tipo_di_produzione: data.tipo_di_produzione,
        address: data.address,
        city: data.city,
        nazione: data.nazione,
        zip_code: data.zip_code,
        region: data.region,
        state: data.state,
        phone: data.phone,
        email: data.email,
        pec: data.pec,
        website: data.website,
        manager_name: data.manager_name,
        manager_phone: data.manager_phone,
        manager_email: data.manager_email,
      };
      
      if (!cantine) {
        await dispatch(
          updateCantineAsync({ cantineId: singleData?.id, cantineData })
        ).unwrap();

        dispatch(fetchCantinesById(singleData?.id));
      } else {
        await dispatch(createCantine(cantineData)).unwrap();
        dispatch(fetchCantines());
        setCantine(false)
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // ENUMS
  const cityOptions = ["Roma", "Milano", "Napoli", "Torino", "Firenze"];
  const frOptions = provincies;
  const regionOptions = [
    "Lazio",
    "Lombardia",
    "Campania",
    "Piemonte",
    "Toscana",
  ];
  const nationOptions = ["Italia", "Francia", "Germania", "Spagna"];

  // cantine certify
  const cantinaCertify = async (singleData) => {
    if (!cantine) {
      try {
        setCertificationLoading(true);
        setCertificationResponse(null);

        // Execute custom external logic
        console.log('Executing certificationProcess...');
        const response = await certificationProcess(singleData, 'cantines');
        console.log('Response: ',response)
        setCertificationResponse(response);


        // Prepare data for certification API call
        // let dataForCertification = {
        //   data_to_certify: customLogicResult.preparedData,
        //   custom_logic_result: customLogicResult,
        //   hook: 'hook-page'
        // };
        // console.log('DataForCertification: ', dataForCertification);

        // Call the certification API
        // const response = await dispatch(certifyCantina({ dataForCertification })).unwrap();
        // setCertificationResponse(response);
        
      } catch (error) {
        console.error("Certification error:", error);
        setCertificationResponse({ error: error.message || "Errore durante la certificazione" });
      } finally {
        setCertificationLoading(false);
      }
    }
  }

  return (
   <> 
    <form className="AziendaFrom" onSubmit={handleSubmit(onSubmit)}>
      
      {/* test */}
      {/* {!cantine && <Typography mb={"10px"}>ID={ singleData?.id }</Typography>} */}
      
      <div className="AziendaFrom__inner">
        <Controller
          defaultValue=""
          name="name"
          control={control}
          render={({ field }) => (
            <TextField
              className="customTextBox"
              {...field}
              label="Nome stabilimento"
              fullWidth
              margin="normal"
              error={!!errors.name}
              helperText={errors.name?.message}
            />
          )}
        />
        <Controller
          name="tipo_di_produzione"
          control={control}
          render={({ field }) => (
            <Autocomplete
              multiple
              disableCloseOnSelect
              options={productionTypes}
              value={field.value || []}
              onChange={(_, value) => field.onChange(value)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  className="customTextBox autoCompleteTextBox"
                  label={field.value && field.value.length > 0 ? '' : 'Tipo di Produzione'}  // Empty label if value exists
                  // placeholder={field.value && field.value.length > 0 ? '' : 'Seleziona tipo'}  // Empty placeholder if value exists
                  error={!!errors.tipo_di_produzione}
                  helperText={errors.tipo_di_produzione?.message}
                  fullWidth
                  margin="normal"
                  InputLabelProps={{ shrink: !!field.value }}  // Ensure label floats above the input
                />
              )}
            />
          )}
        />




        <label className="formLabel">Sede operativa</label>
        <Grid container spacing={0}>
          <Grid size={12}>
            <Controller
            defaultValue=""
              name="address"
              control={control}
              render={({ field }) => (
                <TextField
                  className="customTextBox"
                  {...field}
                  label="Indirizzo"
                  fullWidth
                  margin="normal"
                  error={!!errors.address}
                  helperText={errors.address?.message}
                />
              )}
            />
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid size={8}>
            <Controller
            defaultValue=""
              name="city"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  options={cities ? cities?.map((city) => city.comune) : []}
                  value={field.value || ""}
                  onChange={(event, value) => field.onChange(value)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Città"
                      className="customTextBox autoCompleteTextBox"
                      margin="normal"
                      fullWidth
                      error={!!errors.city}
                      helperText={errors.city?.message}
                    />
                  )}
                />
              )}
            />
          </Grid>
          <Grid size={4}>
            <Controller
            defaultValue=""
              name="zip_code"
              control={control}
              render={({ field }) => (
                <TextField
                  className="customTextBox"
                  {...field}
                  label="CAP"
                  fullWidth
                  margin="normal"
                  error={!!errors.zip_code}
                  helperText={errors.zip_code?.message}
                />
              )}
            />
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid size={3}>
            <Controller
            defaultValue=""
              name="region"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  {...field}
                  options={frOptions ? frOptions.map((fr) => fr.sigla) : []}
                  value={field.value || ""}
                  onChange={(event, value) => field.onChange(value || "")}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="PR"
                      className="customTextBox autoCompleteTextBox"
                      margin="normal"
                      fullWidth
                      error={!!errors.region}
                      helperText={errors.region?.message}
                    />
                  )}
                />
              )}
            />
          </Grid>
          <Grid size={5}>
            <Controller
            defaultValue=""
              name="state"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  {...field}
                  options={regions ? regions?.map((regione) => regione.regione) : []}
                  onChange={(event, value) => field.onChange(value)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Regione"
                      className="customTextBox autoCompleteTextBox"
                      margin="normal"
                      fullWidth
                      error={!!errors.state}
                      helperText={errors.state?.message}
                    />
                  )}
                />
              )}
            />
          </Grid>
          <Grid size={4}>
            <Controller
            defaultValue=""
              name="nazione"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  options={nationOptions}
                  value={field.value || ""}
                  onChange={(event, newValue) => {
                    field.onChange(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Nazione"
                      className="customTextBox autoCompleteTextBox"
                      margin="normal"
                      fullWidth
                      error={!!errors.nazione}
                      helperText={errors.nazione?.message}
                    />
                  )}
                />
              )}
            />

            {/* <Controller
  name="nazione"
  control={control}
  render={({ field }) => (
    <Autocomplete
      options={nationOptions}
      value={field.value || ""}
      onChange={(event, newValue) => {
        field.onChange(newValue);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Nazione (Italian)"
          className="customTextBox autoCompleteTextBox"
          margin="normal"
          fullWidth
          error={!!errors.nazione}
          helperText={errors.nazione?.message}
        />
      )}
    />
  )}
/> */}
          </Grid>
        </Grid>
        <label className="formLabel">Contatti</label>
        <Controller
        defaultValue=""
          name="phone"
          control={control}
          render={({ field }) => (
            <TextField
              className="customTextBox"
              {...field}
              label="Telefono"
              fullWidth
              margin="normal"
              error={!!errors.phone}
              helperText={errors.phone?.message}
            />
          )}
        />{" "}
        <Controller
        defaultValue=""
          name="email"
          control={control}
          render={({ field }) => (
            <TextField
              className="customTextBox"
              {...field}
              label="Email"
              fullWidth
              margin="normal"
              error={!!errors.email}
              helperText={errors.email?.message}
            />
          )}
        />{" "}
        <Controller
        defaultValue=""
          name="pec"
          control={control}
          render={({ field }) => (
            <TextField
              className="customTextBox"
              {...field}
              label="PEC"
              fullWidth
              margin="normal"
              error={!!errors.pec}
              helperText={errors.pec?.message}
            />
          )}
        />{" "}
        <Controller
        defaultValue=""
          name="website"
          control={control}
          render={({ field }) => (
            <TextField
              className="customTextBox"
              {...field}
              label="SitoWeb"
              fullWidth
              margin="normal"
              error={!!errors.website}
              helperText={errors.website?.message}
            />
          )}
        />
        <label className="formLabel">Responsabile aziendale</label>
        <Controller
        defaultValue=""
          name="manager_name"
          control={control}
          render={({ field }) => (
            <TextField
              className="customTextBox"
              {...field}
              label="Nome"
              fullWidth
              margin="normal"
              error={!!errors.manager_name}
              helperText={errors.manager_name?.message}
            />
          )}
        />
        <Controller
        defaultValue=""
          name="manager_phone"
          control={control}
          render={({ field }) => (
            <TextField
              className="customTextBox"
              {...field}
              label="Numero"
              fullWidth
              margin="normal"
              error={!!errors.manager_phone}
              helperText={errors.manager_phone?.message}
            />
          )}
        />
        <Controller
        defaultValue=""
          name="manager_email"
          control={control}
          render={({ field }) => (
            <TextField
              className="customTextBox"
              {...field}
              label="Mail"
              fullWidth
              margin="normal"
              error={!!errors.manager_email}
              helperText={errors.manager_email?.message}
            />
          )}
        />
        <div className="btnPart1">
          <Button type="submit" variant="contained">
            {cantine ? "Salva nuova cantina" : "Salva dati"}
          </Button>
        </div>
      </div>
    </form>


    {!cantine && (
      <div className="px-0 my-5 text-right">
        <Button 
          variant="contained" 
          onClick={() => cantinaCertify(singleData)}
          disabled={certificationLoading}
        >
          {certificationLoading ? "Certificando..." : "Certifica Cantina"}
        </Button>
        
        {/* Display certification response */}
        {certificationResponse && (
          <Box mt={2} p={2} sx={{ 
            backgroundColor: certificationResponse.error ? '#ffebee' : '#e8f5e8',
            border: `1px solid ${certificationResponse.error ? '#f44336' : '#4caf50'}`,
            borderRadius: 1,
            overflowWrap: `break-word`
          }}>
            <Typography 
              variant="body2" 
              color={certificationResponse.error ? 'error' : 'success.main'}
              sx={{ textAlign: 'left' }}
            >
              {certificationResponse.error 
                ? `Errore: ${certificationResponse.error}`
                : JSON.stringify(certificationResponse, null, 2)
              }
            </Typography>
          </Box>
        )}
      </div>
    )}


    </>
  );
};

export default CantineForm;
